
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.1992 13.9388L18.2183 12.342C18.0124 11.9861 17.826 11.3126 17.826 10.9182V8.48447C17.826 6.22384 16.4725 4.27104 14.5206 3.35717C14.0106 2.47215 13.069 1.92383 11.9901 1.92383C10.9209 1.92383 9.95977 2.49139 9.44973 3.38603C7.53711 4.31914 6.21298 6.2527 6.21298 8.48447V10.9182C6.21298 11.3126 6.02663 11.9861 5.82065 12.3324L4.83001 13.9388C4.43768 14.5834 4.3494 15.2952 4.59461 15.9494C4.83001 16.5939 5.38908 17.0941 6.1149 17.3346C8.01772 17.9695 10.0186 18.2773 12.0195 18.2773C14.0204 18.2773 16.0213 17.9695 17.9241 17.3443C18.6107 17.123 19.1403 16.6131 19.3953 15.9494C19.6504 15.2856 19.5817 14.5545 19.1992 13.9388Z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M14.7759 19.2491C14.3639 20.365 13.2752 21.1634 12.0001 21.1634C11.2253 21.1634 10.4602 20.8556 9.92071 20.3072C9.60685 20.0187 9.37145 19.6339 9.23413 19.2395C9.36164 19.2587 9.48915 19.2683 9.62646 19.2876C9.85206 19.3164 10.0875 19.3453 10.3229 19.3646C10.882 19.4126 11.4509 19.4415 12.0197 19.4415C12.5788 19.4415 13.1379 19.4126 13.6872 19.3646C13.8931 19.3453 14.0991 19.3357 14.2953 19.3068C14.4522 19.2876 14.6091 19.2683 14.7759 19.2491Z","fill":"currentColor"}})])
          )
        }
      }
    